<template>
  <v-form ref="form4">
    <div class="d-flex flex-column ga-6">
      <span class="text-heading text-primary text-bold">Beweging</span>
      <v-card class="card w-100 d-flex flex-column ga-10" flat>
        <div class="d-flex flex-column ga-4">
          <span class="text-normal text-primary">Doe je een sport/beweging?</span>
          <v-radio-group class="mt-4" v-model="localQuestions['Beweging?']" :rules="[rules.select_rules.required]">
            <v-radio class="radio-btn-rounded" color="secondary" label="Ja" value="ja" />
            <v-radio class="radio-btn-rounded" color="secondary" label="Nee" value="nee" />
          </v-radio-group>
        </div>
        <div v-if="localQuestions['Beweging?'] == 'ja'" class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary">Wat voor sport doe je?</span>
          <v-text-field color="secondary" v-model="localQuestions['Wat voor sport doe je?']"
            :rules="[rules.text_field_rules.required]" base-color="secondary" variant="underlined" />
        </div>

        <div
          v-if="localQuestions['Beweging?'] == 'ja' && (localQuestions['Wat voor sport doe je?'] != null && localQuestions['Wat voor sport doe je?'] != '')"
          class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary">Hoeveel uur sport je per week?</span>
          <v-slider color="secondary" v-model="localQuestions['Hoeveel uur sport je per week?']" step="1" max="20"
            :rules="[rules.select_rules.required]" thumb-label="always">
            <template v-slot:thumb-label>
              <span>{{ localQuestions['Hoeveel uur sport je per week?'] }} uur</span>
            </template>
          </v-slider>
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary">In mijn vrije tijd</span>
          <v-select class="vragenlijst-v-select" v-model="localQuestions['In mijn vrije tijd']" :items="freetimeoptions"
            color="#000" base-color="#000" placeholder="Selecteer een optie" variant="underlined"
            :rules="[rules.select_rules.required]">
            <template v-slot:append-inner>
              <v-icon class="v-select__menu-icon" color="secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                  <path d="M1 1L7 7L13 1" stroke="#E26D6D" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </v-icon>
            </template>
          </v-select>
        </div>
      </v-card>
    </div>
  </v-form>
</template>

<script>
import FormRules from "@/util/FormRules";

export default {
  props: {
    questions: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.localQuestions['Hoeveel uur sport je per week?'] = 0;
  },
  data() {
    return {
      rules: FormRules.rules,
      freetimeoptions: [
        "Ben ik niet actief (veel zitten, liggen)",
        "Ben ik redelijk actief (boodschappen, huishouden)",
        "Ben ik actief (tuinieren, zwaarder huishouden)",
      ],
      localQuestions: { ...this.questions },
    };
  },
  watch: {
    // Watch for changes in localQuestions and emit updates to the parent
    localQuestions: {
      deep: true,
      handler(newVal) {
        this.$emit("update-questions", newVal);
      },
    },
  },
};
</script>
